import axios from "axios";
import moment from "moment";

export const licoresService = {
  // ============= FUNCIÓN BASE =============
  async apiCall(endpoint, token) {
    try {
      const response = await axios.get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  // ============= MÉTODO PRINCIPAL UNIFICADO =============

  // Obtener todos los datos de licores (comercio, deudas, config, petro)
  async getLicores(idcomercio, token, conexion) {
    // 1. Obtener datos del comercio
    const comercioEndpoint = `${conexion}/api/consulta/modeli?campos=*&id=${idcomercio}&nomtab=comercio&nomid=idcomercio`;
    const comercioResponse = await this.apiCall(comercioEndpoint, token);

    if (comercioResponse.status !== 200 || !comercioResponse.data?.idcomercio) {
      throw new Error("No se encontró el comercio");
    }

    const comercioData = comercioResponse.data;

    // 2. Obtener deudas de licores
    const deudaEndpoint = `${conexion}/api/licores/deudalicores?nomtab=licores&nomid=idcomercio&id=${idcomercio}`;
    const deudaResponse = await this.apiCall(deudaEndpoint, token);

    // 3. Obtener configuración de licores
    let configData = null;
    try {
      const configEndpoint = `${conexion}/api/comun/seleccionaregistros?campos=*&nomtab=configLicores&orden=1`;
      const configResponse = await this.apiCall(configEndpoint, token);
      if (configResponse.status === 200 && configResponse.data?.length > 0) {
        configData = configResponse.data[0];
      }
    } catch (error) {
      console.error("Error al obtener configuración:", error);
    }

    // 4. Obtener valor del petro
    let valorPetro = 0;
    try {
      const petroEndpoint = `${conexion}/api/efiscal/valorpetro`;
      const petroResponse = await this.apiCall(petroEndpoint, token);
      if (petroResponse.status === 200 && petroResponse.data) {
        valorPetro = petroResponse.data.valor || petroResponse.data;
      }
    } catch (error) {
      console.error("Error al obtener valor del petro:", error);
    }

    // 5. Procesar deudas
    const { deuda, historico } = this.mapDeudasLicores(
      deudaResponse.data || [],
    );

    // 6. Retornar todos los datos mapeados
    return {
      status: 200,
      mappedData: {
        comercio: comercioData,
        deuda: deuda,
        historico: historico,
        declaWeb: configData?.declaracionweb || false,
        valorPetro: valorPetro,
      },
    };
  },

  // ============= MÉTODOS ADICIONALES =============

  // Obtener lista de comercios
  async getComercios(token, conexion) {
    const campos = "*";
    const nomtab = "comercio";
    const orden = "idcomercio";
    const endpoint = `${conexion}/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
    return await this.apiCall(endpoint, token);
  },

  // Obtener valor del petro
  async getValorPetro(token, conexion) {
    const endpoint = `${conexion}/api/efiscal/valorpetro`;
    return await this.apiCall(endpoint, token);
  },

  // Obtener configuración de licores
  async getConfiguracion(token, conexion) {
    const endpoint = `${conexion}/api/comun/seleccionaregistros?campos=*&nomtab=configLicores&orden=1`;
    return await this.apiCall(endpoint, token);
  },

  // ============= MAPEADORES =============

  // Mapear datos del comercio
  mapComercioData(data) {
    if (!data) return null;
    return {
      idcomercio: data.idcomercio,
      ritm: data.ritm?.trim().replace(/\s+/g, " ") || "",
      rif: data.rif?.trim().replace(/\s+/g, " ") || "",
      nombre: data.nombre?.trim().replace(/\s+/g, " ") || "",
      reprelegal: data.reprelegal,
    };
  },

  // Mapear deudas de licores
  mapDeudasLicores(data) {
    if (!data || data.length === 0) return { deuda: [], historico: [] };

    const deuda = [];
    const historico = [];

    data.forEach((item) => {
      const mm = item.fechainscripcion
        ? parseInt(
            moment
              .utc(item.fechainscripcion)
              .format("YYYY-MM-DD")
              .substring(5, 7),
          )
        : 0;

      const mes = this.getMesNombre(mm);

      const deudaBase = {
        anio: item.anio,
        mes: mes,
        descripcion: item.descripcion,
        monto: item.monto,
      };

      if (!item.cancelada) {
        deuda.push(deudaBase);
      } else {
        historico.push({
          ...deudaBase,
          numereci: item.numerorecibo || " ",
          fechapago: item.fechapago
            ? moment.utc(item.fechapago).format("YYYY/MM/DD")
            : "",
        });
      }
    });

    return { deuda, historico };
  },

  // Obtener nombre del mes
  getMesNombre(mm) {
    const meses = [
      "ENERO",
      "FEBRERO",
      "MARZO",
      "ABRIL",
      "MAYO",
      "JUNIO",
      "JULIO",
      "AGOSTO",
      "SEPTIEMBRE",
      "OCTUBRE",
      "NOVIEMBRE",
      "DICIEMBRE",
    ];
    return meses[mm - 1] || "";
  },
};
